import React, { useContext } from "react";
import { useParams } from "react-router-dom";
import { GlobalContext } from "../contexts/GlobalContext";
import { useGlobalOrSelected } from "../hooks/useGlobalOrSelected";
import PageHeader from "../components/PageHeader";
import H2HFixtures from "../components/H2HFixtures";
import GameweekNav from "../components/GameweekNav";
import { faFutbol } from "@fortawesome/free-solid-svg-icons";

function H2HFixturesPage() {
  const { globalSeasonId, globalGameweek } = useContext(GlobalContext);
  const { gameweek } = useParams();
  const { getGameweek } = useGlobalOrSelected();

  const gameweekNumber = getGameweek(globalGameweek, gameweek);
  const displayGameweek = Math.max(1, gameweekNumber);

  return (
    <div>
      <PageHeader
        pageTitle="H2H Fixtures"
        gameweek={displayGameweek}
        icon={faFutbol}
      />
      <H2HFixtures seasonId={globalSeasonId} gameweek={displayGameweek} />
      <GameweekNav
        globalGameweek={globalGameweek}
        currentlySelectedGameweek={displayGameweek}
        prefix="h2h"
        future={38 - globalGameweek}
      />
    </div>
  );
}

export default H2HFixturesPage;
